import DownloadGtmContainerComponent from '../../components/download-gtm-container';

export const DownloadSnapchatGtmContainer = () => {
  return <DownloadGtmContainerComponent platformName="Snapchat" />;
};

export default DownloadSnapchatGtmContainer;
